import React, { createContext, Dispatch, useReducer } from 'react';

import {
  Actions,
  AIReducer,
} from '@/modules/AiAgents/context/nugzContext/reducer';
import { IAI } from '@/modules/AiAgents/types';
import { IMessageItemProps } from '@/shared/components/atoms/MessageItem/MessageItem';

export type InitialStateType = {
  isEditing: boolean;
  isLoading: boolean;
  areaUnit: string;
  tableList: IAI.IAIFieldProps[];
  messagesList: IMessageItemProps[];
};

export const initialState: InitialStateType = {
  isEditing: false,
  isLoading: false,
  areaUnit: '',
  messagesList: [],
  tableList: [],
};

const AIContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});

const AIContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(AIReducer, initialState);

  return (
    <AIContext.Provider value={{ state, dispatch }}>
      {children}
    </AIContext.Provider>
  );
};

export { AIContext, AIContextProvider };
